import { EvmNFTCollection } from '@repo/types-client';

import { baseNFTCollections } from './base';
import { ethereumNFTCollections } from './ethereum';
import { baseExternalNFTCollections } from './externalContracts/base/base-external-nft-collections';

export const evmNFTCollections: Record<string, EvmNFTCollection> = {
  ...ethereumNFTCollections,
  ...baseNFTCollections,
  ...baseExternalNFTCollections,
};
